import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import profileService from '../../services/profileService';
import { confirm } from '../common/modals/confirmService'
import QrCode from '../common/modals/qrcode';
import sessionService from '../../services/sessionService';

var usernameRGEX = /^[a-z]+(?:_+[0-9a-z]+)*$/;

class Register extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            email: '',
            password: '',
            error: '',
            showModalQrCode: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.options = {
            autoClose: 3000,
            hideProgressBar: true,
        };
    }

    handleChange = event => {
        const name = event.target.name
        let value = event.target.value
        if ('username' === name) {
            value = value.toLowerCase()
        }
        this.setState({
            [name]: value,
            error: null
        });
    }

    handleSubmit = event => {
        event.preventDefault();
        const user = {
            username: this.state.username,
            password: this.state.password,
            email: this.state.email
        };
        const error = this.validateForm()
        if (!error) {
            profileService.register(user)
                .then(response => {
                    sessionService.create(response);
                    confirm('If you have already Mobile App Free Account, you can connect it with paid account.Do you want to connect your Free App account?').then(() => {
                        this.setState({
                            showModalQrCode: true
                        });
                        toast.success("Account is successfully created!", this.options)
                    }, () => {
                        this.props.history.push("/dashboard/charts");
                        toast.success("Account is successfully created!", this.options)
                    });



                }).catch(error => {
                });
        } else {
            this.setState({ error })
        }
    }

    validateForm() {
        if (!usernameRGEX.test(this.state.username)) {
            return "Username need to start with letter, it need to be at least 5 characters long, can have letters, numbers and underscore and it need to end with letter or number"
        } else if (!this.state.email) {
            return "email is required"
        } else if (!this.state.password || this.state.password.length < 5) {
            return "password need to be longer then 5 characters"
        }
        return null
    }
    handleClose() {
        this.setState({ showModalQrCode: false });
        this.props.history.push("/dashboard/charts");
    }
    render() {

        const { username, password, email, showModalQrCode, error } = this.state;
        return (
            <div className="auth-page-container container-fluid">
                {showModalQrCode ? <QrCode show={showModalQrCode} handleClose={this.handleClose} /> : null}
                <div className="auth-frame jumbotron">
                    <div className="auth-img-box ">
                        <img
                            className="auth-logo"
                            src='/assets/images/logo.png'
                            alt="AirTouch logo"
                        />
                    </div>
                    <form onSubmit={this.handleSubmit} className="text-left">
                        <div className="form-group">
                            <label htmlFor="username">Username:</label>
                            <input id='username' className="form-control" type="text" name="username" value={username} onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email:</label>
                            <input id='email' className="form-control" type="text" name="email" value={email} onChange={this.handleChange} />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password:</label>
                            <input id='password' className="form-control" type="password" name="password" value={password} onChange={this.handleChange} />
                        </div>
                        {error &&
                            <div className={'alert alert-danger'}>{error}</div>
                        }
                        <div className="text-right">
                            <button type="submit" className="btn btn-lightblue">Register</button>
                        </div>

                    </form>
                    <div className="auth-footer">
                        <div>
                            <span>Go back to </span> <Link to="/" >Login.</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/registerComponent/register.js